import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("kgs_token", data.access_token);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-login">
      <motion.form data-testid="admin-login-form" className="login-card" onSubmit={submit}
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}>
        <Logo size={44} />
        <p className="eyebrow">RESTRICTED ACCESS</p>
        <h1>ADMIN<br /><em>TERMINAL.</em></h1>
        <label className="f-label">Email<input data-testid="admin-email-input" type="email" required value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="admin email" /></label>
        <label className="f-label">Password<input data-testid="admin-password-input" type="password" required value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" /></label>
        {error && <p className="login-error" data-testid="admin-login-error">{error}</p>}
        <button data-testid="admin-login-submit" className="btn btn-amber submit" disabled={loading} type="submit">
          {loading ? "Authenticating…" : "Enter dashboard"} <ArrowUpRight size={16} />
        </button>
        <a data-testid="back-to-site-link" className="login-back" href="/">← Back to site</a>
      </motion.form>
    </div>
  );
}
